/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SignupImport } from './routes/signup'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RecoverPasswordImport } from './routes/recover-password'
import { Route as LoginImport } from './routes/login'
import { Route as LayoutImport } from './routes/_layout'
import { Route as IdentifierImport } from './routes/$identifier'
import { Route as LayoutIndexImport } from './routes/_layout/index'
import { Route as LayoutUserManagementImport } from './routes/_layout/user-management'
import { Route as LayoutUserFormImport } from './routes/_layout/user-form'
import { Route as LayoutTemplateFormImport } from './routes/_layout/template-form'
import { Route as LayoutTagsImport } from './routes/_layout/tags'
import { Route as LayoutTagTypesImport } from './routes/_layout/tag-types'
import { Route as LayoutTagTemplatesImport } from './routes/_layout/tag-templates'
import { Route as LayoutTagStatesImport } from './routes/_layout/tag-states'
import { Route as LayoutTagSkusImport } from './routes/_layout/tag-skus'
import { Route as LayoutTagSkuEditorImport } from './routes/_layout/tag-sku-editor'
import { Route as LayoutTagMapImport } from './routes/_layout/tag-map'
import { Route as LayoutTagFormImport } from './routes/_layout/tag-form'
import { Route as LayoutTagDetailImport } from './routes/_layout/tag-detail'
import { Route as LayoutTagCategoriesImport } from './routes/_layout/tag-categories'
import { Route as LayoutSettingsImport } from './routes/_layout/settings'
import { Route as LayoutReadersImport } from './routes/_layout/readers'
import { Route as LayoutReaderFormImport } from './routes/_layout/reader-form'
import { Route as LayoutReaderControlImport } from './routes/_layout/reader-control'
import { Route as LayoutOrganisationsImport } from './routes/_layout/organisations'
import { Route as LayoutOrganisationFormImport } from './routes/_layout/organisation-form'
import { Route as LayoutLicensesImport } from './routes/_layout/licenses'
import { Route as LayoutEventsImport } from './routes/_layout/events'
import { Route as LayoutDebugImport } from './routes/_layout/debug'
import { Route as LayoutDataBrowserImport } from './routes/_layout/data-browser'
import { Route as LayoutApiTokensImport } from './routes/_layout/api-tokens'
import { Route as LayoutApiExplorerImport } from './routes/_layout/api-explorer'
import { Route as LayoutAdminTagsImport } from './routes/_layout/admin-tags'
import { Route as LayoutAdminTableDataImport } from './routes/_layout/admin-table-data'
import { Route as LayoutAdminSystemImport } from './routes/_layout/admin-system'
import { Route as LayoutAdminIpBansImport } from './routes/_layout/admin-ip-bans'
import { Route as LayoutAdminDppImport } from './routes/_layout/admin-dpp'
import { Route as LayoutAdminDemoImport } from './routes/_layout/admin-demo'
import { Route as LayoutAdminDatabaseImport } from './routes/_layout/admin-database'
import { Route as LayoutAdminBrandingImport } from './routes/_layout/admin-branding'
import { Route as LayoutAdminBackupImport } from './routes/_layout/admin-backup'
import { Route as LayoutAdminAuditImport } from './routes/_layout/admin-audit'
import { Route as LayoutAdminImport } from './routes/_layout/admin'
import { Route as LayoutUserPermissionsUserIdImport } from './routes/_layout/user-permissions.$userId'
import { Route as LayoutAdminDppTemplatesImport } from './routes/_layout/admin-dpp.templates'
import { Route as LayoutAdminDppRepresentativesImport } from './routes/_layout/admin-dpp.representatives'
import { Route as LayoutAdminDppRecordsImport } from './routes/_layout/admin-dpp.records'
import { Route as LayoutAdminDppManufacturersImport } from './routes/_layout/admin-dpp.manufacturers'
import { Route as LayoutAdminDppBindingsImport } from './routes/_layout/admin-dpp.bindings'

// Create/Update Routes

const SignupRoute = SignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RecoverPasswordRoute = RecoverPasswordImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const IdentifierRoute = IdentifierImport.update({
  id: '/$identifier',
  path: '/$identifier',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUserManagementRoute = LayoutUserManagementImport.update({
  id: '/user-management',
  path: '/user-management',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUserFormRoute = LayoutUserFormImport.update({
  id: '/user-form',
  path: '/user-form',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTemplateFormRoute = LayoutTemplateFormImport.update({
  id: '/template-form',
  path: '/template-form',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagsRoute = LayoutTagsImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagTypesRoute = LayoutTagTypesImport.update({
  id: '/tag-types',
  path: '/tag-types',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagTemplatesRoute = LayoutTagTemplatesImport.update({
  id: '/tag-templates',
  path: '/tag-templates',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagStatesRoute = LayoutTagStatesImport.update({
  id: '/tag-states',
  path: '/tag-states',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagSkusRoute = LayoutTagSkusImport.update({
  id: '/tag-skus',
  path: '/tag-skus',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagSkuEditorRoute = LayoutTagSkuEditorImport.update({
  id: '/tag-sku-editor',
  path: '/tag-sku-editor',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagMapRoute = LayoutTagMapImport.update({
  id: '/tag-map',
  path: '/tag-map',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagFormRoute = LayoutTagFormImport.update({
  id: '/tag-form',
  path: '/tag-form',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagDetailRoute = LayoutTagDetailImport.update({
  id: '/tag-detail',
  path: '/tag-detail',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutTagCategoriesRoute = LayoutTagCategoriesImport.update({
  id: '/tag-categories',
  path: '/tag-categories',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSettingsRoute = LayoutSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutReadersRoute = LayoutReadersImport.update({
  id: '/readers',
  path: '/readers',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutReaderFormRoute = LayoutReaderFormImport.update({
  id: '/reader-form',
  path: '/reader-form',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutReaderControlRoute = LayoutReaderControlImport.update({
  id: '/reader-control',
  path: '/reader-control',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutOrganisationsRoute = LayoutOrganisationsImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutOrganisationFormRoute = LayoutOrganisationFormImport.update({
  id: '/organisation-form',
  path: '/organisation-form',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLicensesRoute = LayoutLicensesImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEventsRoute = LayoutEventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDebugRoute = LayoutDebugImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDataBrowserRoute = LayoutDataBrowserImport.update({
  id: '/data-browser',
  path: '/data-browser',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutApiTokensRoute = LayoutApiTokensImport.update({
  id: '/api-tokens',
  path: '/api-tokens',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutApiExplorerRoute = LayoutApiExplorerImport.update({
  id: '/api-explorer',
  path: '/api-explorer',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminTagsRoute = LayoutAdminTagsImport.update({
  id: '/admin-tags',
  path: '/admin-tags',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminTableDataRoute = LayoutAdminTableDataImport.update({
  id: '/admin-table-data',
  path: '/admin-table-data',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminSystemRoute = LayoutAdminSystemImport.update({
  id: '/admin-system',
  path: '/admin-system',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminIpBansRoute = LayoutAdminIpBansImport.update({
  id: '/admin-ip-bans',
  path: '/admin-ip-bans',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminDppRoute = LayoutAdminDppImport.update({
  id: '/admin-dpp',
  path: '/admin-dpp',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminDemoRoute = LayoutAdminDemoImport.update({
  id: '/admin-demo',
  path: '/admin-demo',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminDatabaseRoute = LayoutAdminDatabaseImport.update({
  id: '/admin-database',
  path: '/admin-database',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminBrandingRoute = LayoutAdminBrandingImport.update({
  id: '/admin-branding',
  path: '/admin-branding',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminBackupRoute = LayoutAdminBackupImport.update({
  id: '/admin-backup',
  path: '/admin-backup',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminAuditRoute = LayoutAdminAuditImport.update({
  id: '/admin-audit',
  path: '/admin-audit',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAdminRoute = LayoutAdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutUserPermissionsUserIdRoute =
  LayoutUserPermissionsUserIdImport.update({
    id: '/user-permissions/$userId',
    path: '/user-permissions/$userId',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutAdminDppTemplatesRoute = LayoutAdminDppTemplatesImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => LayoutAdminDppRoute,
} as any)

const LayoutAdminDppRepresentativesRoute =
  LayoutAdminDppRepresentativesImport.update({
    id: '/representatives',
    path: '/representatives',
    getParentRoute: () => LayoutAdminDppRoute,
  } as any)

const LayoutAdminDppRecordsRoute = LayoutAdminDppRecordsImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => LayoutAdminDppRoute,
} as any)

const LayoutAdminDppManufacturersRoute =
  LayoutAdminDppManufacturersImport.update({
    id: '/manufacturers',
    path: '/manufacturers',
    getParentRoute: () => LayoutAdminDppRoute,
  } as any)

const LayoutAdminDppBindingsRoute = LayoutAdminDppBindingsImport.update({
  id: '/bindings',
  path: '/bindings',
  getParentRoute: () => LayoutAdminDppRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$identifier': {
      id: '/$identifier'
      path: '/$identifier'
      fullPath: '/$identifier'
      preLoaderRoute: typeof IdentifierImport
      parentRoute: typeof rootRoute
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupImport
      parentRoute: typeof rootRoute
    }
    '/_layout/admin': {
      id: '/_layout/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof LayoutAdminImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-audit': {
      id: '/_layout/admin-audit'
      path: '/admin-audit'
      fullPath: '/admin-audit'
      preLoaderRoute: typeof LayoutAdminAuditImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-backup': {
      id: '/_layout/admin-backup'
      path: '/admin-backup'
      fullPath: '/admin-backup'
      preLoaderRoute: typeof LayoutAdminBackupImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-branding': {
      id: '/_layout/admin-branding'
      path: '/admin-branding'
      fullPath: '/admin-branding'
      preLoaderRoute: typeof LayoutAdminBrandingImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-database': {
      id: '/_layout/admin-database'
      path: '/admin-database'
      fullPath: '/admin-database'
      preLoaderRoute: typeof LayoutAdminDatabaseImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-demo': {
      id: '/_layout/admin-demo'
      path: '/admin-demo'
      fullPath: '/admin-demo'
      preLoaderRoute: typeof LayoutAdminDemoImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-dpp': {
      id: '/_layout/admin-dpp'
      path: '/admin-dpp'
      fullPath: '/admin-dpp'
      preLoaderRoute: typeof LayoutAdminDppImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-ip-bans': {
      id: '/_layout/admin-ip-bans'
      path: '/admin-ip-bans'
      fullPath: '/admin-ip-bans'
      preLoaderRoute: typeof LayoutAdminIpBansImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-system': {
      id: '/_layout/admin-system'
      path: '/admin-system'
      fullPath: '/admin-system'
      preLoaderRoute: typeof LayoutAdminSystemImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-table-data': {
      id: '/_layout/admin-table-data'
      path: '/admin-table-data'
      fullPath: '/admin-table-data'
      preLoaderRoute: typeof LayoutAdminTableDataImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-tags': {
      id: '/_layout/admin-tags'
      path: '/admin-tags'
      fullPath: '/admin-tags'
      preLoaderRoute: typeof LayoutAdminTagsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/api-explorer': {
      id: '/_layout/api-explorer'
      path: '/api-explorer'
      fullPath: '/api-explorer'
      preLoaderRoute: typeof LayoutApiExplorerImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/api-tokens': {
      id: '/_layout/api-tokens'
      path: '/api-tokens'
      fullPath: '/api-tokens'
      preLoaderRoute: typeof LayoutApiTokensImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/data-browser': {
      id: '/_layout/data-browser'
      path: '/data-browser'
      fullPath: '/data-browser'
      preLoaderRoute: typeof LayoutDataBrowserImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/debug': {
      id: '/_layout/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof LayoutDebugImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/events': {
      id: '/_layout/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof LayoutEventsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/licenses': {
      id: '/_layout/licenses'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof LayoutLicensesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/organisation-form': {
      id: '/_layout/organisation-form'
      path: '/organisation-form'
      fullPath: '/organisation-form'
      preLoaderRoute: typeof LayoutOrganisationFormImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/organisations': {
      id: '/_layout/organisations'
      path: '/organisations'
      fullPath: '/organisations'
      preLoaderRoute: typeof LayoutOrganisationsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/reader-control': {
      id: '/_layout/reader-control'
      path: '/reader-control'
      fullPath: '/reader-control'
      preLoaderRoute: typeof LayoutReaderControlImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/reader-form': {
      id: '/_layout/reader-form'
      path: '/reader-form'
      fullPath: '/reader-form'
      preLoaderRoute: typeof LayoutReaderFormImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/readers': {
      id: '/_layout/readers'
      path: '/readers'
      fullPath: '/readers'
      preLoaderRoute: typeof LayoutReadersImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-categories': {
      id: '/_layout/tag-categories'
      path: '/tag-categories'
      fullPath: '/tag-categories'
      preLoaderRoute: typeof LayoutTagCategoriesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-detail': {
      id: '/_layout/tag-detail'
      path: '/tag-detail'
      fullPath: '/tag-detail'
      preLoaderRoute: typeof LayoutTagDetailImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-form': {
      id: '/_layout/tag-form'
      path: '/tag-form'
      fullPath: '/tag-form'
      preLoaderRoute: typeof LayoutTagFormImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-map': {
      id: '/_layout/tag-map'
      path: '/tag-map'
      fullPath: '/tag-map'
      preLoaderRoute: typeof LayoutTagMapImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-sku-editor': {
      id: '/_layout/tag-sku-editor'
      path: '/tag-sku-editor'
      fullPath: '/tag-sku-editor'
      preLoaderRoute: typeof LayoutTagSkuEditorImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-skus': {
      id: '/_layout/tag-skus'
      path: '/tag-skus'
      fullPath: '/tag-skus'
      preLoaderRoute: typeof LayoutTagSkusImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-states': {
      id: '/_layout/tag-states'
      path: '/tag-states'
      fullPath: '/tag-states'
      preLoaderRoute: typeof LayoutTagStatesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-templates': {
      id: '/_layout/tag-templates'
      path: '/tag-templates'
      fullPath: '/tag-templates'
      preLoaderRoute: typeof LayoutTagTemplatesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tag-types': {
      id: '/_layout/tag-types'
      path: '/tag-types'
      fullPath: '/tag-types'
      preLoaderRoute: typeof LayoutTagTypesImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/tags': {
      id: '/_layout/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof LayoutTagsImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/template-form': {
      id: '/_layout/template-form'
      path: '/template-form'
      fullPath: '/template-form'
      preLoaderRoute: typeof LayoutTemplateFormImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/user-form': {
      id: '/_layout/user-form'
      path: '/user-form'
      fullPath: '/user-form'
      preLoaderRoute: typeof LayoutUserFormImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/user-management': {
      id: '/_layout/user-management'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof LayoutUserManagementImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/admin-dpp/bindings': {
      id: '/_layout/admin-dpp/bindings'
      path: '/bindings'
      fullPath: '/admin-dpp/bindings'
      preLoaderRoute: typeof LayoutAdminDppBindingsImport
      parentRoute: typeof LayoutAdminDppImport
    }
    '/_layout/admin-dpp/manufacturers': {
      id: '/_layout/admin-dpp/manufacturers'
      path: '/manufacturers'
      fullPath: '/admin-dpp/manufacturers'
      preLoaderRoute: typeof LayoutAdminDppManufacturersImport
      parentRoute: typeof LayoutAdminDppImport
    }
    '/_layout/admin-dpp/records': {
      id: '/_layout/admin-dpp/records'
      path: '/records'
      fullPath: '/admin-dpp/records'
      preLoaderRoute: typeof LayoutAdminDppRecordsImport
      parentRoute: typeof LayoutAdminDppImport
    }
    '/_layout/admin-dpp/representatives': {
      id: '/_layout/admin-dpp/representatives'
      path: '/representatives'
      fullPath: '/admin-dpp/representatives'
      preLoaderRoute: typeof LayoutAdminDppRepresentativesImport
      parentRoute: typeof LayoutAdminDppImport
    }
    '/_layout/admin-dpp/templates': {
      id: '/_layout/admin-dpp/templates'
      path: '/templates'
      fullPath: '/admin-dpp/templates'
      preLoaderRoute: typeof LayoutAdminDppTemplatesImport
      parentRoute: typeof LayoutAdminDppImport
    }
    '/_layout/user-permissions/$userId': {
      id: '/_layout/user-permissions/$userId'
      path: '/user-permissions/$userId'
      fullPath: '/user-permissions/$userId'
      preLoaderRoute: typeof LayoutUserPermissionsUserIdImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

interface LayoutAdminDppRouteChildren {
  LayoutAdminDppBindingsRoute: typeof LayoutAdminDppBindingsRoute
  LayoutAdminDppManufacturersRoute: typeof LayoutAdminDppManufacturersRoute
  LayoutAdminDppRecordsRoute: typeof LayoutAdminDppRecordsRoute
  LayoutAdminDppRepresentativesRoute: typeof LayoutAdminDppRepresentativesRoute
  LayoutAdminDppTemplatesRoute: typeof LayoutAdminDppTemplatesRoute
}

const LayoutAdminDppRouteChildren: LayoutAdminDppRouteChildren = {
  LayoutAdminDppBindingsRoute: LayoutAdminDppBindingsRoute,
  LayoutAdminDppManufacturersRoute: LayoutAdminDppManufacturersRoute,
  LayoutAdminDppRecordsRoute: LayoutAdminDppRecordsRoute,
  LayoutAdminDppRepresentativesRoute: LayoutAdminDppRepresentativesRoute,
  LayoutAdminDppTemplatesRoute: LayoutAdminDppTemplatesRoute,
}

const LayoutAdminDppRouteWithChildren = LayoutAdminDppRoute._addFileChildren(
  LayoutAdminDppRouteChildren,
)

interface LayoutRouteChildren {
  LayoutAdminRoute: typeof LayoutAdminRoute
  LayoutAdminAuditRoute: typeof LayoutAdminAuditRoute
  LayoutAdminBackupRoute: typeof LayoutAdminBackupRoute
  LayoutAdminBrandingRoute: typeof LayoutAdminBrandingRoute
  LayoutAdminDatabaseRoute: typeof LayoutAdminDatabaseRoute
  LayoutAdminDemoRoute: typeof LayoutAdminDemoRoute
  LayoutAdminDppRoute: typeof LayoutAdminDppRouteWithChildren
  LayoutAdminIpBansRoute: typeof LayoutAdminIpBansRoute
  LayoutAdminSystemRoute: typeof LayoutAdminSystemRoute
  LayoutAdminTableDataRoute: typeof LayoutAdminTableDataRoute
  LayoutAdminTagsRoute: typeof LayoutAdminTagsRoute
  LayoutApiExplorerRoute: typeof LayoutApiExplorerRoute
  LayoutApiTokensRoute: typeof LayoutApiTokensRoute
  LayoutDataBrowserRoute: typeof LayoutDataBrowserRoute
  LayoutDebugRoute: typeof LayoutDebugRoute
  LayoutEventsRoute: typeof LayoutEventsRoute
  LayoutLicensesRoute: typeof LayoutLicensesRoute
  LayoutOrganisationFormRoute: typeof LayoutOrganisationFormRoute
  LayoutOrganisationsRoute: typeof LayoutOrganisationsRoute
  LayoutReaderControlRoute: typeof LayoutReaderControlRoute
  LayoutReaderFormRoute: typeof LayoutReaderFormRoute
  LayoutReadersRoute: typeof LayoutReadersRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutTagCategoriesRoute: typeof LayoutTagCategoriesRoute
  LayoutTagDetailRoute: typeof LayoutTagDetailRoute
  LayoutTagFormRoute: typeof LayoutTagFormRoute
  LayoutTagMapRoute: typeof LayoutTagMapRoute
  LayoutTagSkuEditorRoute: typeof LayoutTagSkuEditorRoute
  LayoutTagSkusRoute: typeof LayoutTagSkusRoute
  LayoutTagStatesRoute: typeof LayoutTagStatesRoute
  LayoutTagTemplatesRoute: typeof LayoutTagTemplatesRoute
  LayoutTagTypesRoute: typeof LayoutTagTypesRoute
  LayoutTagsRoute: typeof LayoutTagsRoute
  LayoutTemplateFormRoute: typeof LayoutTemplateFormRoute
  LayoutUserFormRoute: typeof LayoutUserFormRoute
  LayoutUserManagementRoute: typeof LayoutUserManagementRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutUserPermissionsUserIdRoute: typeof LayoutUserPermissionsUserIdRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAdminRoute: LayoutAdminRoute,
  LayoutAdminAuditRoute: LayoutAdminAuditRoute,
  LayoutAdminBackupRoute: LayoutAdminBackupRoute,
  LayoutAdminBrandingRoute: LayoutAdminBrandingRoute,
  LayoutAdminDatabaseRoute: LayoutAdminDatabaseRoute,
  LayoutAdminDemoRoute: LayoutAdminDemoRoute,
  LayoutAdminDppRoute: LayoutAdminDppRouteWithChildren,
  LayoutAdminIpBansRoute: LayoutAdminIpBansRoute,
  LayoutAdminSystemRoute: LayoutAdminSystemRoute,
  LayoutAdminTableDataRoute: LayoutAdminTableDataRoute,
  LayoutAdminTagsRoute: LayoutAdminTagsRoute,
  LayoutApiExplorerRoute: LayoutApiExplorerRoute,
  LayoutApiTokensRoute: LayoutApiTokensRoute,
  LayoutDataBrowserRoute: LayoutDataBrowserRoute,
  LayoutDebugRoute: LayoutDebugRoute,
  LayoutEventsRoute: LayoutEventsRoute,
  LayoutLicensesRoute: LayoutLicensesRoute,
  LayoutOrganisationFormRoute: LayoutOrganisationFormRoute,
  LayoutOrganisationsRoute: LayoutOrganisationsRoute,
  LayoutReaderControlRoute: LayoutReaderControlRoute,
  LayoutReaderFormRoute: LayoutReaderFormRoute,
  LayoutReadersRoute: LayoutReadersRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutTagCategoriesRoute: LayoutTagCategoriesRoute,
  LayoutTagDetailRoute: LayoutTagDetailRoute,
  LayoutTagFormRoute: LayoutTagFormRoute,
  LayoutTagMapRoute: LayoutTagMapRoute,
  LayoutTagSkuEditorRoute: LayoutTagSkuEditorRoute,
  LayoutTagSkusRoute: LayoutTagSkusRoute,
  LayoutTagStatesRoute: LayoutTagStatesRoute,
  LayoutTagTemplatesRoute: LayoutTagTemplatesRoute,
  LayoutTagTypesRoute: LayoutTagTypesRoute,
  LayoutTagsRoute: LayoutTagsRoute,
  LayoutTemplateFormRoute: LayoutTemplateFormRoute,
  LayoutUserFormRoute: LayoutUserFormRoute,
  LayoutUserManagementRoute: LayoutUserManagementRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutUserPermissionsUserIdRoute: LayoutUserPermissionsUserIdRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '/$identifier': typeof IdentifierRoute
  '': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin': typeof LayoutAdminRoute
  '/admin-audit': typeof LayoutAdminAuditRoute
  '/admin-backup': typeof LayoutAdminBackupRoute
  '/admin-branding': typeof LayoutAdminBrandingRoute
  '/admin-database': typeof LayoutAdminDatabaseRoute
  '/admin-demo': typeof LayoutAdminDemoRoute
  '/admin-dpp': typeof LayoutAdminDppRouteWithChildren
  '/admin-ip-bans': typeof LayoutAdminIpBansRoute
  '/admin-system': typeof LayoutAdminSystemRoute
  '/admin-table-data': typeof LayoutAdminTableDataRoute
  '/admin-tags': typeof LayoutAdminTagsRoute
  '/api-explorer': typeof LayoutApiExplorerRoute
  '/api-tokens': typeof LayoutApiTokensRoute
  '/data-browser': typeof LayoutDataBrowserRoute
  '/debug': typeof LayoutDebugRoute
  '/events': typeof LayoutEventsRoute
  '/licenses': typeof LayoutLicensesRoute
  '/organisation-form': typeof LayoutOrganisationFormRoute
  '/organisations': typeof LayoutOrganisationsRoute
  '/reader-control': typeof LayoutReaderControlRoute
  '/reader-form': typeof LayoutReaderFormRoute
  '/readers': typeof LayoutReadersRoute
  '/settings': typeof LayoutSettingsRoute
  '/tag-categories': typeof LayoutTagCategoriesRoute
  '/tag-detail': typeof LayoutTagDetailRoute
  '/tag-form': typeof LayoutTagFormRoute
  '/tag-map': typeof LayoutTagMapRoute
  '/tag-sku-editor': typeof LayoutTagSkuEditorRoute
  '/tag-skus': typeof LayoutTagSkusRoute
  '/tag-states': typeof LayoutTagStatesRoute
  '/tag-templates': typeof LayoutTagTemplatesRoute
  '/tag-types': typeof LayoutTagTypesRoute
  '/tags': typeof LayoutTagsRoute
  '/template-form': typeof LayoutTemplateFormRoute
  '/user-form': typeof LayoutUserFormRoute
  '/user-management': typeof LayoutUserManagementRoute
  '/': typeof LayoutIndexRoute
  '/admin-dpp/bindings': typeof LayoutAdminDppBindingsRoute
  '/admin-dpp/manufacturers': typeof LayoutAdminDppManufacturersRoute
  '/admin-dpp/records': typeof LayoutAdminDppRecordsRoute
  '/admin-dpp/representatives': typeof LayoutAdminDppRepresentativesRoute
  '/admin-dpp/templates': typeof LayoutAdminDppTemplatesRoute
  '/user-permissions/$userId': typeof LayoutUserPermissionsUserIdRoute
}

export interface FileRoutesByTo {
  '/$identifier': typeof IdentifierRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin': typeof LayoutAdminRoute
  '/admin-audit': typeof LayoutAdminAuditRoute
  '/admin-backup': typeof LayoutAdminBackupRoute
  '/admin-branding': typeof LayoutAdminBrandingRoute
  '/admin-database': typeof LayoutAdminDatabaseRoute
  '/admin-demo': typeof LayoutAdminDemoRoute
  '/admin-dpp': typeof LayoutAdminDppRouteWithChildren
  '/admin-ip-bans': typeof LayoutAdminIpBansRoute
  '/admin-system': typeof LayoutAdminSystemRoute
  '/admin-table-data': typeof LayoutAdminTableDataRoute
  '/admin-tags': typeof LayoutAdminTagsRoute
  '/api-explorer': typeof LayoutApiExplorerRoute
  '/api-tokens': typeof LayoutApiTokensRoute
  '/data-browser': typeof LayoutDataBrowserRoute
  '/debug': typeof LayoutDebugRoute
  '/events': typeof LayoutEventsRoute
  '/licenses': typeof LayoutLicensesRoute
  '/organisation-form': typeof LayoutOrganisationFormRoute
  '/organisations': typeof LayoutOrganisationsRoute
  '/reader-control': typeof LayoutReaderControlRoute
  '/reader-form': typeof LayoutReaderFormRoute
  '/readers': typeof LayoutReadersRoute
  '/settings': typeof LayoutSettingsRoute
  '/tag-categories': typeof LayoutTagCategoriesRoute
  '/tag-detail': typeof LayoutTagDetailRoute
  '/tag-form': typeof LayoutTagFormRoute
  '/tag-map': typeof LayoutTagMapRoute
  '/tag-sku-editor': typeof LayoutTagSkuEditorRoute
  '/tag-skus': typeof LayoutTagSkusRoute
  '/tag-states': typeof LayoutTagStatesRoute
  '/tag-templates': typeof LayoutTagTemplatesRoute
  '/tag-types': typeof LayoutTagTypesRoute
  '/tags': typeof LayoutTagsRoute
  '/template-form': typeof LayoutTemplateFormRoute
  '/user-form': typeof LayoutUserFormRoute
  '/user-management': typeof LayoutUserManagementRoute
  '/': typeof LayoutIndexRoute
  '/admin-dpp/bindings': typeof LayoutAdminDppBindingsRoute
  '/admin-dpp/manufacturers': typeof LayoutAdminDppManufacturersRoute
  '/admin-dpp/records': typeof LayoutAdminDppRecordsRoute
  '/admin-dpp/representatives': typeof LayoutAdminDppRepresentativesRoute
  '/admin-dpp/templates': typeof LayoutAdminDppTemplatesRoute
  '/user-permissions/$userId': typeof LayoutUserPermissionsUserIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/$identifier': typeof IdentifierRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/_layout/admin': typeof LayoutAdminRoute
  '/_layout/admin-audit': typeof LayoutAdminAuditRoute
  '/_layout/admin-backup': typeof LayoutAdminBackupRoute
  '/_layout/admin-branding': typeof LayoutAdminBrandingRoute
  '/_layout/admin-database': typeof LayoutAdminDatabaseRoute
  '/_layout/admin-demo': typeof LayoutAdminDemoRoute
  '/_layout/admin-dpp': typeof LayoutAdminDppRouteWithChildren
  '/_layout/admin-ip-bans': typeof LayoutAdminIpBansRoute
  '/_layout/admin-system': typeof LayoutAdminSystemRoute
  '/_layout/admin-table-data': typeof LayoutAdminTableDataRoute
  '/_layout/admin-tags': typeof LayoutAdminTagsRoute
  '/_layout/api-explorer': typeof LayoutApiExplorerRoute
  '/_layout/api-tokens': typeof LayoutApiTokensRoute
  '/_layout/data-browser': typeof LayoutDataBrowserRoute
  '/_layout/debug': typeof LayoutDebugRoute
  '/_layout/events': typeof LayoutEventsRoute
  '/_layout/licenses': typeof LayoutLicensesRoute
  '/_layout/organisation-form': typeof LayoutOrganisationFormRoute
  '/_layout/organisations': typeof LayoutOrganisationsRoute
  '/_layout/reader-control': typeof LayoutReaderControlRoute
  '/_layout/reader-form': typeof LayoutReaderFormRoute
  '/_layout/readers': typeof LayoutReadersRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/tag-categories': typeof LayoutTagCategoriesRoute
  '/_layout/tag-detail': typeof LayoutTagDetailRoute
  '/_layout/tag-form': typeof LayoutTagFormRoute
  '/_layout/tag-map': typeof LayoutTagMapRoute
  '/_layout/tag-sku-editor': typeof LayoutTagSkuEditorRoute
  '/_layout/tag-skus': typeof LayoutTagSkusRoute
  '/_layout/tag-states': typeof LayoutTagStatesRoute
  '/_layout/tag-templates': typeof LayoutTagTemplatesRoute
  '/_layout/tag-types': typeof LayoutTagTypesRoute
  '/_layout/tags': typeof LayoutTagsRoute
  '/_layout/template-form': typeof LayoutTemplateFormRoute
  '/_layout/user-form': typeof LayoutUserFormRoute
  '/_layout/user-management': typeof LayoutUserManagementRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/admin-dpp/bindings': typeof LayoutAdminDppBindingsRoute
  '/_layout/admin-dpp/manufacturers': typeof LayoutAdminDppManufacturersRoute
  '/_layout/admin-dpp/records': typeof LayoutAdminDppRecordsRoute
  '/_layout/admin-dpp/representatives': typeof LayoutAdminDppRepresentativesRoute
  '/_layout/admin-dpp/templates': typeof LayoutAdminDppTemplatesRoute
  '/_layout/user-permissions/$userId': typeof LayoutUserPermissionsUserIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$identifier'
    | ''
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/admin'
    | '/admin-audit'
    | '/admin-backup'
    | '/admin-branding'
    | '/admin-database'
    | '/admin-demo'
    | '/admin-dpp'
    | '/admin-ip-bans'
    | '/admin-system'
    | '/admin-table-data'
    | '/admin-tags'
    | '/api-explorer'
    | '/api-tokens'
    | '/data-browser'
    | '/debug'
    | '/events'
    | '/licenses'
    | '/organisation-form'
    | '/organisations'
    | '/reader-control'
    | '/reader-form'
    | '/readers'
    | '/settings'
    | '/tag-categories'
    | '/tag-detail'
    | '/tag-form'
    | '/tag-map'
    | '/tag-sku-editor'
    | '/tag-skus'
    | '/tag-states'
    | '/tag-templates'
    | '/tag-types'
    | '/tags'
    | '/template-form'
    | '/user-form'
    | '/user-management'
    | '/'
    | '/admin-dpp/bindings'
    | '/admin-dpp/manufacturers'
    | '/admin-dpp/records'
    | '/admin-dpp/representatives'
    | '/admin-dpp/templates'
    | '/user-permissions/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$identifier'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/admin'
    | '/admin-audit'
    | '/admin-backup'
    | '/admin-branding'
    | '/admin-database'
    | '/admin-demo'
    | '/admin-dpp'
    | '/admin-ip-bans'
    | '/admin-system'
    | '/admin-table-data'
    | '/admin-tags'
    | '/api-explorer'
    | '/api-tokens'
    | '/data-browser'
    | '/debug'
    | '/events'
    | '/licenses'
    | '/organisation-form'
    | '/organisations'
    | '/reader-control'
    | '/reader-form'
    | '/readers'
    | '/settings'
    | '/tag-categories'
    | '/tag-detail'
    | '/tag-form'
    | '/tag-map'
    | '/tag-sku-editor'
    | '/tag-skus'
    | '/tag-states'
    | '/tag-templates'
    | '/tag-types'
    | '/tags'
    | '/template-form'
    | '/user-form'
    | '/user-management'
    | '/'
    | '/admin-dpp/bindings'
    | '/admin-dpp/manufacturers'
    | '/admin-dpp/records'
    | '/admin-dpp/representatives'
    | '/admin-dpp/templates'
    | '/user-permissions/$userId'
  id:
    | '__root__'
    | '/$identifier'
    | '/_layout'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/signup'
    | '/_layout/admin'
    | '/_layout/admin-audit'
    | '/_layout/admin-backup'
    | '/_layout/admin-branding'
    | '/_layout/admin-database'
    | '/_layout/admin-demo'
    | '/_layout/admin-dpp'
    | '/_layout/admin-ip-bans'
    | '/_layout/admin-system'
    | '/_layout/admin-table-data'
    | '/_layout/admin-tags'
    | '/_layout/api-explorer'
    | '/_layout/api-tokens'
    | '/_layout/data-browser'
    | '/_layout/debug'
    | '/_layout/events'
    | '/_layout/licenses'
    | '/_layout/organisation-form'
    | '/_layout/organisations'
    | '/_layout/reader-control'
    | '/_layout/reader-form'
    | '/_layout/readers'
    | '/_layout/settings'
    | '/_layout/tag-categories'
    | '/_layout/tag-detail'
    | '/_layout/tag-form'
    | '/_layout/tag-map'
    | '/_layout/tag-sku-editor'
    | '/_layout/tag-skus'
    | '/_layout/tag-states'
    | '/_layout/tag-templates'
    | '/_layout/tag-types'
    | '/_layout/tags'
    | '/_layout/template-form'
    | '/_layout/user-form'
    | '/_layout/user-management'
    | '/_layout/'
    | '/_layout/admin-dpp/bindings'
    | '/_layout/admin-dpp/manufacturers'
    | '/_layout/admin-dpp/records'
    | '/_layout/admin-dpp/representatives'
    | '/_layout/admin-dpp/templates'
    | '/_layout/user-permissions/$userId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IdentifierRoute: typeof IdentifierRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
}

const rootRouteChildren: RootRouteChildren = {
  IdentifierRoute: IdentifierRoute,
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/$identifier",
        "/_layout",
        "/login",
        "/recover-password",
        "/reset-password",
        "/signup"
      ]
    },
    "/$identifier": {
      "filePath": "$identifier.tsx"
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/admin",
        "/_layout/admin-audit",
        "/_layout/admin-backup",
        "/_layout/admin-branding",
        "/_layout/admin-database",
        "/_layout/admin-demo",
        "/_layout/admin-dpp",
        "/_layout/admin-ip-bans",
        "/_layout/admin-system",
        "/_layout/admin-table-data",
        "/_layout/admin-tags",
        "/_layout/api-explorer",
        "/_layout/api-tokens",
        "/_layout/data-browser",
        "/_layout/debug",
        "/_layout/events",
        "/_layout/licenses",
        "/_layout/organisation-form",
        "/_layout/organisations",
        "/_layout/reader-control",
        "/_layout/reader-form",
        "/_layout/readers",
        "/_layout/settings",
        "/_layout/tag-categories",
        "/_layout/tag-detail",
        "/_layout/tag-form",
        "/_layout/tag-map",
        "/_layout/tag-sku-editor",
        "/_layout/tag-skus",
        "/_layout/tag-states",
        "/_layout/tag-templates",
        "/_layout/tag-types",
        "/_layout/tags",
        "/_layout/template-form",
        "/_layout/user-form",
        "/_layout/user-management",
        "/_layout/",
        "/_layout/user-permissions/$userId"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/recover-password": {
      "filePath": "recover-password.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/signup": {
      "filePath": "signup.tsx"
    },
    "/_layout/admin": {
      "filePath": "_layout/admin.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-audit": {
      "filePath": "_layout/admin-audit.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-backup": {
      "filePath": "_layout/admin-backup.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-branding": {
      "filePath": "_layout/admin-branding.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-database": {
      "filePath": "_layout/admin-database.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-demo": {
      "filePath": "_layout/admin-demo.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-dpp": {
      "filePath": "_layout/admin-dpp.tsx",
      "parent": "/_layout",
      "children": [
        "/_layout/admin-dpp/bindings",
        "/_layout/admin-dpp/manufacturers",
        "/_layout/admin-dpp/records",
        "/_layout/admin-dpp/representatives",
        "/_layout/admin-dpp/templates"
      ]
    },
    "/_layout/admin-ip-bans": {
      "filePath": "_layout/admin-ip-bans.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-system": {
      "filePath": "_layout/admin-system.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-table-data": {
      "filePath": "_layout/admin-table-data.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-tags": {
      "filePath": "_layout/admin-tags.tsx",
      "parent": "/_layout"
    },
    "/_layout/api-explorer": {
      "filePath": "_layout/api-explorer.tsx",
      "parent": "/_layout"
    },
    "/_layout/api-tokens": {
      "filePath": "_layout/api-tokens.tsx",
      "parent": "/_layout"
    },
    "/_layout/data-browser": {
      "filePath": "_layout/data-browser.tsx",
      "parent": "/_layout"
    },
    "/_layout/debug": {
      "filePath": "_layout/debug.tsx",
      "parent": "/_layout"
    },
    "/_layout/events": {
      "filePath": "_layout/events.tsx",
      "parent": "/_layout"
    },
    "/_layout/licenses": {
      "filePath": "_layout/licenses.tsx",
      "parent": "/_layout"
    },
    "/_layout/organisation-form": {
      "filePath": "_layout/organisation-form.tsx",
      "parent": "/_layout"
    },
    "/_layout/organisations": {
      "filePath": "_layout/organisations.tsx",
      "parent": "/_layout"
    },
    "/_layout/reader-control": {
      "filePath": "_layout/reader-control.tsx",
      "parent": "/_layout"
    },
    "/_layout/reader-form": {
      "filePath": "_layout/reader-form.tsx",
      "parent": "/_layout"
    },
    "/_layout/readers": {
      "filePath": "_layout/readers.tsx",
      "parent": "/_layout"
    },
    "/_layout/settings": {
      "filePath": "_layout/settings.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-categories": {
      "filePath": "_layout/tag-categories.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-detail": {
      "filePath": "_layout/tag-detail.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-form": {
      "filePath": "_layout/tag-form.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-map": {
      "filePath": "_layout/tag-map.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-sku-editor": {
      "filePath": "_layout/tag-sku-editor.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-skus": {
      "filePath": "_layout/tag-skus.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-states": {
      "filePath": "_layout/tag-states.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-templates": {
      "filePath": "_layout/tag-templates.tsx",
      "parent": "/_layout"
    },
    "/_layout/tag-types": {
      "filePath": "_layout/tag-types.tsx",
      "parent": "/_layout"
    },
    "/_layout/tags": {
      "filePath": "_layout/tags.tsx",
      "parent": "/_layout"
    },
    "/_layout/template-form": {
      "filePath": "_layout/template-form.tsx",
      "parent": "/_layout"
    },
    "/_layout/user-form": {
      "filePath": "_layout/user-form.tsx",
      "parent": "/_layout"
    },
    "/_layout/user-management": {
      "filePath": "_layout/user-management.tsx",
      "parent": "/_layout"
    },
    "/_layout/": {
      "filePath": "_layout/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/admin-dpp/bindings": {
      "filePath": "_layout/admin-dpp.bindings.tsx",
      "parent": "/_layout/admin-dpp"
    },
    "/_layout/admin-dpp/manufacturers": {
      "filePath": "_layout/admin-dpp.manufacturers.tsx",
      "parent": "/_layout/admin-dpp"
    },
    "/_layout/admin-dpp/records": {
      "filePath": "_layout/admin-dpp.records.tsx",
      "parent": "/_layout/admin-dpp"
    },
    "/_layout/admin-dpp/representatives": {
      "filePath": "_layout/admin-dpp.representatives.tsx",
      "parent": "/_layout/admin-dpp"
    },
    "/_layout/admin-dpp/templates": {
      "filePath": "_layout/admin-dpp.templates.tsx",
      "parent": "/_layout/admin-dpp"
    },
    "/_layout/user-permissions/$userId": {
      "filePath": "_layout/user-permissions.$userId.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
